/**
 * The workhorse salon: a rectangular top-lit picture gallery in the wing's
 * colour, organic gallery-wall clusters on the long walls. This is the
 * exemplar room type — read alongside docs/palace-room-types.md.
 */

import { PALACE } from '../constants';
import { rectSegments } from '../hang';

const gallery = {
  id: 'gallery',
  role: 'wing',
  weight: 5,

  // axis is the travel direction through the room ('x' or 'z'): make the
  // room longer along the walk so the enfilade reads.
  plan(rand, { axis }) {
    const long = 9.5 + rand() * 3.5;
    const cross = 8 + rand() * 2.5;
    return {
      w: axis === 'x' ? long : cross,
      d: axis === 'x' ? cross : long,
      height: PALACE.WALL_H,
    };
  },

  segments(node) {
    return rectSegments(node, { longStyle: 'cluster', shortStyle: 'cluster' });
  },

  build(node, T) {
    const { group, colliders } = T.standardShell(node, T.kit);
    const cx = (node.x1 + node.x2) / 2;
    const cz = (node.z1 + node.z2) / 2;
    const along = node.x2 - node.x1 >= node.z2 - node.z1;
    const b = T.bench(
      T.kit,
      cx + (along ? 0 : (T.rand() < 0.5 ? -1 : 1) * 1.4),
      cz + (along ? (T.rand() < 0.5 ? -1 : 1) * 1.4 : 0),
      along ? 0 : Math.PI / 2
    );
    group.add(b.mesh);
    colliders.push(b.collider);
    return { group, colliders };
  },
};

export default gallery;
